/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { withNamespaces } from 'react-i18next';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { hideElementCss, showElementCss } from '../../../../utils/responsive';
import MediaQueries from '../../../../styles/Grid/MediaQueries';
import { navbar_finite_state } from '../../../../contexts/NavContext';
import { NAVBAR_IDS } from '../../../../utils/constants';
import { RegusLogo, LOGO_TYPES } from '../../../ui/RegusLogo';
import {
  buttonReset,
  listCss,
  menuSizeCss,
  regusLogoCss,
  waysToWorkCss,
  waysToWorkButtonCss,
  phoneSizeCss,
  phoneButtonCss,
  searchSizeCss,
  profileSizeCss,
  profileButtonCss,
  loginCss,
  verticalLineCss,
  flexWrapperCss,
  regusLogoWrapperCss,
  activeSearchTextCss,
  searchButtonCss,
  hoverStyleHamburguerCss,
  verticalLineDarkModeCss,
  iconCloserSizeCss,
  containerAnimationCss,
  circleHoverCss,
  animationContainerCss,
  flexContainer,
  hoverStyleIconCss,
  activeCss,
  activeWaysToWorkCss,
  searchLocationTextCss,
} from './index.styles';

const Nav = ({
  clickedItem,
  closeModal,
  isModalOpen,
  language,
  membership,
  onClickItem,
  closeText,
  t,
  waysToWorkText,
}) => (
  <React.Fragment>
    <div
      css={[
        flexWrapperCss,
        isModalOpen && showElementCss(MediaQueries.lgAndUp, 'flex'),
      ]}
    >
      <button
        id={
          isModalOpen ? NAVBAR_IDS.WAYS_TO_WORK_ACTIVE : NAVBAR_IDS.WAYS_TO_WORK
        }
        onClick={onClickItem}
        data-id={navbar_finite_state.WAYS_TO_WORK}
        aria-label={t(waysToWorkText.value)}
        css={[
          buttonReset,
          flexWrapperCss,
          waysToWorkButtonCss,
          containerAnimationCss(isModalOpen),
          clickedItem === navbar_finite_state.WAYS_TO_WORK &&
            activeWaysToWorkCss(isModalOpen),
        ]}
      >
        <span css={animationContainerCss}>
          <span
            css={[menuSizeCss, hoverStyleHamburguerCss]}
            className="icon-ways-to-work icon-menu"
          />
          <span css={circleHoverCss} className="circle-hover" />
        </span>
        <span
          className="translate-text"
          css={[waysToWorkCss, hideElementCss(MediaQueries.sm)]}
        >
          <Text field={waysToWorkText} />
        </span>
      </button>
    </div>
    <div
      css={[
        regusLogoWrapperCss,
        isModalOpen && showElementCss(MediaQueries.lgAndUp),
      ]}
    >
      <a
        aria-label="regus logo"
        css={[buttonReset, flexWrapperCss]}
        href={`/${language.toLowerCase()}`}
        id={NAVBAR_IDS.HOME}
      >
        <RegusLogo
          customCss={regusLogoCss}
          type={isModalOpen && LOGO_TYPES.WHITE}
        />
      </a>
    </div>
    <div>
      <ul css={listCss}>
        <li css={isModalOpen && showElementCss(MediaQueries.lgAndUp)}>
          <button
            id={isModalOpen ? NAVBAR_IDS.CONTACT_ACTIVE : NAVBAR_IDS.CONTACT}
            onClick={onClickItem}
            data-id={navbar_finite_state.CONTACT}
            aria-label="Contact"
            css={[
              buttonReset,
              flexWrapperCss,
              phoneButtonCss,
              containerAnimationCss(isModalOpen),
              clickedItem === navbar_finite_state.CONTACT && activeCss,
            ]}
          >
            <span css={animationContainerCss}>
              <i
                css={[phoneSizeCss, hoverStyleIconCss]}
                className="icon-phone"
              />
              <span css={circleHoverCss} className="circle-hover" />
            </span>
          </button>
        </li>
        <li
          css={[
            hideElementCss(MediaQueries.sm),
            isModalOpen && showElementCss(MediaQueries.lgAndUp),
          ]}
        >
          <div
            css={[verticalLineCss, isModalOpen && verticalLineDarkModeCss]}
          />
        </li>
        <li css={[isModalOpen && showElementCss(MediaQueries.lgAndUp)]}>
          <button
            id={isModalOpen ? NAVBAR_IDS.SEARCH_ACTIVE : NAVBAR_IDS.SEARCH}
            onClick={onClickItem}
            data-id={navbar_finite_state.SEARCH}
            aria-label="Search"
            css={[
              buttonReset,
              searchButtonCss,
              flexWrapperCss,
              containerAnimationCss(isModalOpen),
            ]}
          >
            <span css={animationContainerCss}>
              <i
                css={[
                  hoverStyleIconCss,
                  searchSizeCss,
                  isModalOpen && activeCss,
                ]}
                className="icon-search"
              />
              <span
                css={!isModalOpen && circleHoverCss}
                className="circle-hover"
              />
            </span>
            <span
              className="translate-text"
              css={[
                searchLocationTextCss,
                isModalOpen && activeSearchTextCss,
                showElementCss(MediaQueries.lgAndUp),
              ]}
            >
              {t('SearchLocation')}
            </span>
          </button>
        </li>
        <li
          css={[flexContainer, !isModalOpen && hideElementCss(MediaQueries.sm)]}
        >
          {isModalOpen ? (
            <button
              id={isModalOpen ? NAVBAR_IDS.CLOSE_ACTIVE : NAVBAR_IDS.CLOSE}
              onClick={closeModal}
              data-id={navbar_finite_state.CLOSE}
              aria-label={closeText}
              css={[
                buttonReset,
                flexWrapperCss,
                containerAnimationCss(isModalOpen),
              ]}
            >
              <span css={animationContainerCss}>
                <i
                  css={[profileSizeCss, iconCloserSizeCss, hoverStyleIconCss]}
                  className="icon-closer"
                />
                <span css={circleHoverCss} className="circle-hover" />
              </span>
              <span className="translate-text" css={loginCss}>
                {t('Close')}
              </span>
            </button>
          ) : (
            <a
              className="menu-overlay"
              aria-label={membership.value.text}
              css={[
                buttonReset,
                flexWrapperCss,
                profileButtonCss,
                containerAnimationCss(isModalOpen),
              ]}
              href={membership.value.href}
              id={NAVBAR_IDS.LOGIN}
              rel="noopener noreferrer"
              target={membership.value.target}
            >
              <span css={animationContainerCss}>
                <i
                  css={[profileSizeCss, hoverStyleIconCss]}
                  className="icon-profile"
                />
                <span css={circleHoverCss} className="circle-hover" />
              </span>
              <span
                className="translate-text"
                css={[loginCss, showElementCss(MediaQueries.xl)]}
              >
                {membership.value.text}
              </span>
            </a>
          )}
        </li>
      </ul>
    </div>
  </React.Fragment>
);

Nav.defaultProps = {
  language: '',
  t: key => key,
};

export default withNamespaces()(Nav);
